import { render, staticRenderFns } from "./NewPatch.vue?vue&type=template&id=46a89f19&"
import script from "./NewPatch.vue?vue&type=script&lang=js&"
export * from "./NewPatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports